/* eslint-disable no-undef */

/** Outlook-Client für plattformspezifisches OAuth-/Autorun-Verhalten. */
export type OutlookHostKind =
  | "ios"
  | "android"
  | "web"
  | "newOutlook"
  | "classicWindows"
  | "classicMac"
  | "unknown";

export function detectOutlookHostKind(): OutlookHostKind {
  try {
    const hn = String(Office.context?.mailbox?.diagnostics?.hostName ?? "").trim();
    if (hn === "OutlookIOS") return "ios";
    if (hn === "OutlookAndroid") return "android";
    if (hn === "OutlookWebApp") return "web";
    if (hn === "newOutlookWindows") return "newOutlook";
    if (hn === "Outlook") {
      const plat = Office.context?.platform;
      if (plat === Office.PlatformType.Mac) return "classicMac";
      if (plat === Office.PlatformType.PC) return "classicWindows";
      return "classicWindows";
    }
  } catch {
    /* ignore */
  }
  return "unknown";
}

export function isMobileOutlookHostKind(kind: OutlookHostKind): boolean {
  return kind === "ios" || kind === "android";
}

/** Pause nach interaktivem OAuth/SSO, bevor Compose-APIs aufgerufen werden. */
export function getMobileOAuthResumeDelayMs(kind: OutlookHostKind, usedInteractiveAuth: boolean): number {
  if (!usedInteractiveAuth) return 0;
  if (kind === "android") return 650;
  if (kind === "ios") return 650;
  return 0;
}

/** Nach Schließen des OAuth-Dialogs: Compose kurz warten (iOS/Android). */
export function getDialogCloseToComposeDelayMs(kind: OutlookHostKind): number {
  if (kind === "android") return 900;
  if (kind === "ios") return 500;
  return 0;
}

/** Mobil-Launch: Token nur über API-Brücke (kein großes JWT per messageParent). */
export function shouldHandOffLaunchTokenViaBridge(kind: OutlookHostKind): boolean {
  return isMobileOutlookHostKind(kind);
}
